module.exports = __webpack_public_path__ + "img/index_style2.f83562bb.jpg";